"use client";

import { PropsWithChildren } from "react";

import { GlobalAlert } from "~~/app/common/GlobalAlert";
import { MainPageFooter } from "~~/app/common/layouts/MainPageFooter";
import { MainPageHeader } from "~~/app/common/layouts/MainPageHeader";

export default function Layout({ children }: PropsWithChildren<{}>) {
  return (
    <div className="min-h-screen bg-[#2B0928] flex flex-col">
      <GlobalAlert />
      <MainPageHeader />
      <div className="flex-grow flex justify-start flex-col">{children}</div>
      <MainPageFooter />
    </div>
  );
}
